import { axios } from "@/libraries/axios";
import { parseDate } from "@/libraries/dayjs-relative";
import type {
	EventItem,
	GetEventResponse,
	PayloadCreateEvent,
	PayloadUpdateEvent,
} from "@/types";
import type { AxiosRequestConfig } from "axios";
import omit from "lodash/omit";

class EventService {
	async getEvent(id: number, config?: AxiosRequestConfig) {
		try {
			const res = await axios.get<GetEventResponse>(
				`/api/v1/events/${id}`,
				config,
			);
			return res.data;
		} catch (error) {
			return Promise.reject(error);
		}
	}
	createEvent(payload: PayloadCreateEvent) {
		return axios.post("/api/v1/events", payload);
	}
	updateEvent({ id, ...payload }: PayloadUpdateEvent) {
		return axios.patch(`/api/v1/events/${id}`, payload);
	}
	deleteEvent(id: number) {
		return axios.delete(`/api/v1/events/${id}`);
	}
	copyEvent(event: EventItem) {
		const cleanupEvent = omit(event, ["id", "created_at", "updated_at"]);
		const payload = {
			...cleanupEvent,
			...(cleanupEvent.with_timezone
				? {
						start_datetime: parseDate(cleanupEvent.start_datetime).format(
							"YYYY-MM-DD HH:mm:ss Z",
						),
						end_datetime: parseDate(cleanupEvent.end_datetime).format(
							"YYYY-MM-DD HH:mm:ss Z",
						),
					}
				: {}),
		};
		return axios.post("/api/v1/events", payload);
	}
}

export const eventService = Object.freeze(new EventService());
